import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col, Select, Checkbox, DatePicker } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../components/RecordStatus";
import { fxRateSetupAPI, fxRateSetupLabel, fxRateSetupStatic } from "../ManageFxRate.config";
import appStatic from "../../../../config/appStatic";

const { Text, Title } = Typography;

const DetailPRD0602 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const {monthList} = appStatic;
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [fxRateDetail, setFxRateDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${fxRateSetupAPI.FxRates}/${state.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setFxRateDetail(objDetail);
        setIsLoading(false);

        setInputField([
          {
            name: fxRateSetupLabel.currencyCode1,
            value: objDetail.fromCurrencyData.displayLabel,
          },
          {
            name: fxRateSetupLabel.currencyCode2,
            value: objDetail.toCurrencyData.displayLabel,
          },
          {
            name: fxRateSetupLabel.conversionType,
            value: objDetail.conversionType,
          },
          {
            name: fxRateSetupLabel.conversionCurrency,
            value: objDetail?.conversionCurrencyData?.displayLabel ? objDetail?.conversionCurrencyData?.displayLabel : "-",
          },
          {
            name: fxRateSetupLabel.rateDate,
            value:  objDetail?.date ? (`${objDetail?.date[2]} ${monthList[objDetail?.date[1] - 1]} ${objDetail?.date[0]}`)
            : "-",
          },
          {
            name: fxRateSetupLabel.rateType,
            value: objDetail.rateType,
          },
          {
            name: fxRateSetupLabel.midRate,
            value: objDetail.midRate,
          },
          {
            name: fxRateSetupLabel.buyRate,
            value: objDetail.buyRate,
          },
          {
            name: fxRateSetupLabel.saleRate,
            value: objDetail.saleRate,
          },
          {
            name: fxRateSetupLabel.saleSpread,
            value: objDetail.saleSpread,
          },
          {
            name: fxRateSetupLabel.buySpread,
            value: objDetail.buySpread,
          },
        ]);
        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };


  return (
    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={fxRateSetupLabel.rateSetupDetail}
        pageItems={fxRateSetupStatic.detailFxRateItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {fxRateSetupLabel.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input
                      disabled
                      value={item.value}
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </Card>
      
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailPRD0602);
